import React, { useMemo, useState } from 'react';
import { NavLink, useParams } from 'react-router-dom';
import classes from './configuration.module.scss';
import accountHelpers from '../../../../utils/accountHelpers';
import { ReactComponent as SearchIcon } from '../../../../assets/icons/search.svg';
import { ReactComponent as ChevronIcon } from '../../../../assets/icons/arrow_down.svg';
import { ReactComponent as ProfileIcon } from '../../../../assets/icons/physicianUser.svg';
import { ReactComponent as JCodeIcon } from '../../../../assets/icons/j_code.svg';

const getGroups = (userId) => [
  {
    name: 'People & Access',
    color: 'pink',
    items: [
      {
        title: 'Profile',
        subtitle: 'Your account',
        path: `/team/${userId}/profile/edit`,
        icon: <ProfileIcon />,
      },
    ],
  },
  {
    name: 'Insurance & Billing',
    color: 'blue',
    items: [
      {
        title: 'J-Code settings',
        subtitle: 'Drug billing codes',
        path: `/team/${userId}/profile/j-codes`,
        icon: <JCodeIcon />,
      },
    ],
  },
];

const TeamProfile = () => {
  const { userId } = useParams();

  const [search, setSearch] = useState('');

  const groups = useMemo(
    () => getGroups(userId || accountHelpers.getUser()?.id),
    [userId],
  );

  const filteredGroups = useMemo(() => {
    const value = search.trim().toLowerCase();

    if (!value) return groups;

    return groups.map((group) => ({
        ...group,
        items: group.items.filter((i) => `${i.title} ${i.subtitle}`.toLowerCase().includes(value)),
      })).filter((group) => group.items.length);
  }, [groups, search]);

  const sectionsCount = groups.reduce((acc, group) => acc + group.items.length, 0);

  return (
    <div className={classes.configuration}>
      <div className={classes.head}>
        <div>
          <h1>Configuration</h1>

          <p>
            {sectionsCount}
            {sectionsCount === 1 ? ' section' : ' sections'}
            {' across '}
            {groups.length}
            {groups.length === 1 ? ' category' : ' categories'}
          </p>
        </div>

        <div className={classes.search}>
          <SearchIcon />

          <input
            type="text"
            value={search}
            placeholder="Search settings..."
            onChange={(e) => setSearch(e.target.value)}
          />
        </div>
      </div>

      {filteredGroups.map((group) => (
        <div key={group.name} className={classes.group}>
          <div className={classes.group_head}>
            <span>{group.name}</span>

            <em>{group.items.length}</em>

            <i />
          </div>

          <div className={classes.grid}>
            {group.items.map((item) => (
              <NavLink
                key={item.title}
                to={item.path}
                className={`${classes.card} ${classes[group.color]}`}
              >
                <span className={classes.tile}>{item.icon}</span>

                <span className={classes.text}>
                  <b>{item.title}</b>

                  <em>{item.subtitle}</em>
                </span>

                <span className={classes.chevron}><ChevronIcon /></span>
              </NavLink>
            ))}
          </div>
        </div>
      ))}

      {!filteredGroups.length && (
        <p className={classes.empty}>No settings match your search.</p>
      )}
    </div>
  );
};

export default TeamProfile;
